import {App, Divider, Input, Select as AntSelect} from "antd";
import {configConfirmModal} from "@/theme/config/confirmModalConfirm";
import {useEffect, useState} from "react";
import {useDebounce, useTempData} from "@/lib/hook";
import {api} from "@/lib/api/api";
export const Select = ({onChange, confirm, ...rest}) => {
    const {modal} = App.useApp();

    return (
        <>
            <AntSelect
                style={{
                    width: '100%',
                }}
                onChange={async (value, option) => {
                    if (confirm) {
                        modal.confirm(configConfirmModal({
                            ...confirm,
                            onOk: () =>{
                                if (onChange){
                                    onChange(value, option)
                                }
                            }
                        }))
                    } else {
                        if (onChange) {
                            onChange(value, option)
                        }
                    }
                }}
                {...rest}
            />
        </>
    );
}

const initFilterData = {
    options: [],
    pagination: {
        current_page: 0,
        total_pages: null,
    },
}
export const PaginationItemSelect = ({optionsFilter, requestSearchName, requestFilter, routeName, requestDataName, transform, ...rest}) => {
    const {data, setTempData} = useTempData(`select.${requestDataName}`, initFilterData)
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(null);
    const debounce = useDebounce(search, 500)

    useEffect(() => {
        loadData(debounce)
    }, [debounce])

    useEffect(() => {
        return () =>{
            loadData(null)
        }
    }, [])

    const onScroll = (event) => {
        const target = event.target;
        if (
            !loading &&
            target.scrollTop + target.offsetHeight === target.scrollHeight
        ) {
            target.scrollTo(0, target.scrollHeight);
            loadData(debounce)
        }
    }

    const loadData = (search) => {
        if (data.pagination.total_pages !== data.pagination.current_page) {
            fetchData(search, data.pagination.current_page + 1)
        }
    }

    const fetchData = (search, page) => {
        setLoading(true);
        api.send({
            route: {name: routeName},
            data: {
                page,
                ...requestFilter,
                [requestSearchName]: search
            }
        })
            .then((resp) => {
                if (resp && resp.data) {
                    let options;
                    if (search && resp.data.meta.pagination.current_page === 1) {
                        options = resp.data[requestDataName]
                            ? resp.data[requestDataName].map((item) => transform(item))
                            : []
                    } else {
                        let currentOptions = data.options
                        if (!search && resp.data.meta.pagination.current_page === 1){
                            currentOptions = []
                        }

                        options = resp.data[requestDataName]
                            ? [
                                ...currentOptions,
                                ...resp.data[requestDataName].map((item) => transform(item))
                            ]
                            : []
                    }

                    setTempData({
                        ...data,
                        pagination: resp.data.meta.pagination,
                        options,
                    })
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const optionsOnSearch = (value) => {
        setTempData({
            ...data,
            pagination: {
                current_page: 0,
                total_pages: null,
            },
        })
        setSearch(() => value || null)
    }

    const optionsFiltered = () => {
        if (data.options && optionsFilter){
            return optionsFilter(data.options)
        }
        return data.options
    }

    return (
        <>
            <Select
                style={{
                    width: '100%',
                }}
                loading={loading}
                onPopupScroll={onScroll}
                filterOption={false}
                showSearch={false}
                dropdownRender={(menu) => (
                    <>
                        <Input
                            placeholder="Please enter item name"
                            value={search}
                            onChange={(e)=>{
                                optionsOnSearch(e.target.value)
                            }}
                            onKeyDown={(e) => e.stopPropagation()}
                        />
                        <Divider
                            style={{
                                margin: '8px 0',
                            }}
                        />
                        {menu}
                    </>
                )}
                {...rest}
            >
                {optionsFiltered().map((el) => (
                    <AntSelect.Option
                        key={el.value}
                        {...el}
                    >
                        {el.label}
                    </AntSelect.Option>
                ))}
                {loading && <AntSelect.Option value={'load'}>Loading...</AntSelect.Option>}
            </Select>
        </>
    );
}